export const sortUserMenus = (menuList) => {
  return menuList.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
};
